import { render, staticRenderFns } from "./ThreeDots.vue?vue&type=template&id=f3af1d7c&"
import script from "./ThreeDots.vue?vue&type=script&lang=js&"
export * from "./ThreeDots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports